export default __webpack_public_path__ + "static/media/peerling_video_preview.909cf2a8.jpg";